import React, { Component } from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Auth wrapper
import Auth from '../Auth'

// Actions
import { login, getAuthResources } from '../../actions/auth'
import { setLanguage, setNextLanguage, InitLanguage, setTranslations, setLanguages } from '../../language'
import { setPhoneCodes, setBrands, setEnums, setCountries, setVehicleLookupServices } from '../../actions/common'

// Elements
import Panel from '../../shared/elements/panel'
import Text from '../../shared/elements/text'
import Button from '../../shared/elements/button'

// Utils
import { translation } from '../../utils/helpers'

// Components
import ForgotPasswordModal from '../../shared/modals/ForgotPasswordModal'

// Redux
import store from '../../store'

// import styles
import './login.scss'

class Login extends Component {

  constructor (props) {
    super(props)
    this.onSubmit = this.onSubmit.bind(this)
    this.onChange = this.onChange.bind(this)

    this.state = {
      UserName: '',
      Password: '',
      errors: false,
      isLoading: false,
      modal: false,
      spinnerShow: false
    }

    this.toggleForgotPassword = this.toggleForgotPassword.bind(this)
  }

  componentWillMount () {
    if (this.props.auth.isAuthenticated) {
      if (this.props.router !== undefined) {
        this.props.router.push('/')
      } else {
        this.props.this.props.router.push('/')  // this.props.this.props ? copy/paste mistake or hacks? hmm..
      }
    }
  }

  componentDidMount () {
    // get resources if missing
    let common = this.props.common
    if (common.phonecodes.length === 0 ||
      common.brands.length === 0 ||
      common.countries.length === 0) {
      InitLanguage().then((res) => {
        // Set translations
        store.dispatch(setTranslations(res.translations))
        store.dispatch(setLanguages(res.langs))

        // Set rest
        store.dispatch(setPhoneCodes(res.data.PhoneCodes))
        store.dispatch(setBrands(res.data.Brands))
        store.dispatch(setEnums(res.data.Enums))
        store.dispatch(setCountries(res.data.Countries))
        store.dispatch(setVehicleLookupServices(res.data.VehicleLookupServices))

        // Set user language
        if (typeof window.localStorage.user_language !== 'undefined') {
          store.dispatch(setLanguage(window.localStorage.user_language))
        }
      })
    }
  }

  loadingSpinner () {
    return (
      <div className='animated-background'>
        <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
        <span className='sr-only'>{translation('13382')}...</span>
      </div>
    )
  }

  onSubmit (e) {
    e.preventDefault()
    this.setState({ errors: false, isLoading: true })
    let UserName = this.refs.UserName.value || this.state.UserName
    let Password = this.refs.password.value || this.state.Password

    // Validate input
    if (UserName === '' || Password === '') {
      this.setState({ errors: '17', isLoading: false })
      return
    }

    this.props.login({
      UserName: UserName,
      Password: Password
    }).then(
      (loginRes) => {
        setTimeout(() => {
          if (window.sock.readyState === window.sock.OPEN) {
            window.sock.send(JSON.stringify({
              Type: 'CONNECTION',
              ShopId: parseInt(JSON.parse(window.localStorage.user_data).ShopId)
            }))
          }
        }, 3000)
        // console.log('Login res', res.data)

        // if (res.data.ShopSubscriptionType !== undefined && res.data.ShopSubscriptionType === 1) {
        //   this.props.router.push('/')
        // }
        this.props.getAuthResources().then((res) => {
          if (res.data.Permissions.ShopSubscriptionValue === 0) {
            this.props.router.push('/')
          } else {
            console.log(loginRes.data.UserType)
            if (loginRes.data.UserType === 8) {
              this.props.router.push('/selectshop')
            } else if (loginRes.data.UserType === 5) {
              this.props.router.push('/workscreen')
            } else if (loginRes.data.UserType === 3) {
              if (loginRes.data.StartScreen !== null) {
                this.props.router.push(loginRes.data.StartScreen)
              } else {
                this.props.router.push('/workscreen')
              }
            } else {
              this.props.router.push('/orders')
            }
          }
        })
      },
      (err) => {
        if (err.response.status === 401) {
          this.setState({ spinnerShow: true })
          let delay = err.response.data.Parameters[0]
          setTimeout(() => {
            this.setState({ errors: '3', isLoading: false, spinnerShow: false, Password: '' })
          }, delay * 1000)

          this.refs.password.value = ''
        } else {
          this.setState({ errors: 'Network error. Try again later.', isLoading: false })
        }
      }
    )
  }

  onChange (e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  renderGetStarted () {
    if (window.location.host !== 'web.apromas.com') return null
    return (
      <div className='main__right'>
        <h2>{translation('2143')}</h2>
        <p>Lorem ipsum ...</p>
        <p>{translation('2122')} <Link to='/signup' className='green'>{translation('2123')}</Link></p>
        <Link to='/signup' className='button'>{translation('2120')}</Link>
      </div>
    )
  }

  toggleForgotPassword (e) {
    if (e !== undefined) {
      e.preventDefault()
    }
    this.setState({
      modal: !this.state.modal
    })
  }

  render () {
    const { errors, isLoading, spinnerShow } = this.state

    let className = 'spinner-bg '
    if (spinnerShow) {
      className += 'show'
    }

    return (
      <div>
        <div className={className}>
          {spinnerShow && this.loadingSpinner()}
        </div>
        <Auth router={this.props.router}>
          <div className='login__screen'>
            <div className='login__layout'>
              <Panel>
                <h3 className='title'>{translation('2124')}</h3>
                {errors && <div className='alert alert-danger'>{translation(errors)}</div>}
                <form onSubmit={this.onSubmit}>
                  <Text ref='UserName' name='UserName' onChange={this.onChange} labelText={translation('1')} autoComplete='off' />
                  <Text ref='password' isPassword name='Password' onChange={this.onChange} labelText={translation('2')} autoComplete='off' />
                  <div className='links clearfix'>
                    <Button disabled={isLoading} labelText={translation('13355')} onClick={this.onSubmit} />
                    <a href='/activate/'>{translation('16388')}</a>
                    <a href='' onClick={this.toggleForgotPassword}>{translation('2144')}</a>
                  </div>
                </form>
                {this.renderGetStarted()}
              </Panel>
            </div>
            <ForgotPasswordModal show={this.state.modal} onClose={this.toggleForgotPassword.bind(this)} />
          </div>
        </Auth>
      </div>
    )
  }

}

Login.propTypes = {
  auth: PropTypes.object.isRequired,
  login: PropTypes.func.isRequired,
  setLanguage: PropTypes.func.isRequired,
  setNextLanguage: PropTypes.func.isRequired,
  getAuthResources: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    common: state.common
  }
}

export default connect(mapStateToProps, { login, setLanguage, setNextLanguage, getAuthResources })(Login)



// WEBPACK FOOTER //
// ./src/app/pages/Login/index.js